import './button.css';
export default {
  "badge": "pf-v5-c-badge",
  "button": "pf-v5-c-button",
  "buttonCount": "pf-v5-c-button__count",
  "buttonIcon": "pf-v5-c-button__icon",
  "buttonProgress": "pf-v5-c-button__progress",
  "modifiers": {
    "active": "pf-m-active",
    "block": "pf-m-block",
    "small": "pf-m-small",
    "primary": "pf-m-primary",
    "displayLg": "pf-m-display-lg",
    "secondary": "pf-m-secondary",
    "tertiary": "pf-m-tertiary",
    "link": "pf-m-link",
    "unread": "pf-m-unread",
    "inline": "pf-m-inline",
    "danger": "pf-m-danger",
    "warning": "pf-m-warning",
    "control": "pf-m-control",
    "expanded": "pf-m-expanded",
    "plain": "pf-m-plain",
    "noPadding": "pf-m-no-padding",
    "disabled": "pf-m-disabled",
    "ariaDisabled": "pf-m-aria-disabled",
    "progress": "pf-m-progress",
    "inProgress": "pf-m-in-progress",
    "start": "pf-m-start",
    "end": "pf-m-end"
  },
  "spinner": "pf-v5-c-spinner",
  "themeDark": "pf-v5-theme-dark"
};